import React, { useContext } from 'react';
import { LanguageContext } from '../LanguageContext';

// Custom hook that returns the pages with translated headers
export const usePages = () => {
    const { t } = useContext(LanguageContext);
    return [
        {
            header: t('needs_article1_title'),
            textBase: 'needs',
        },
        {
            header: t('needs_article2_title'),
            textBase: 'needs2',
        },
    ];
};

export default usePages;